import { useState } from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/sonner';
import { subscribeNewsletter } from '@/lib/api';
import { NEWSLETTER } from '@/constants/testIds';

function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

// Footer newsletter/lead-capture signup. Stores the email in MongoDB via
// /api/newsletter/subscribe (no outbound email sending yet — connect a
// provider later to actually deliver a welcome/lead-magnet email).
export const NewsletterSignup = ({ className = '' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      toast.error('Please enter a valid email address.');
      return;
    }
    setStatus('loading');
    try {
      const res = await subscribeNewsletter(email.trim().toLowerCase());
      setStatus('success');
      setEmail('');
      toast.success(res.message || 'Thanks for subscribing!');
    } catch (err) {
      setStatus('error');
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`flex flex-col sm:flex-row gap-3 ${className}`} data-testid={NEWSLETTER.form}>
      <Input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        aria-label="Email address"
        data-testid={NEWSLETTER.input}
        className="bg-[#141416] border-[hsl(var(--lxra-border))] text-[hsl(var(--lxra-fg))] placeholder:text-[hsl(var(--lxra-muted))] focus-visible:ring-[hsl(var(--lxra-gold))] h-10"
      />
      <Button
        type="submit"
        disabled={status === 'loading'}
        data-testid={NEWSLETTER.submitButton}
        className="h-10 px-5 rounded-lg bg-[hsl(var(--lxra-gold))] text-[#0A0A0A] hover:bg-[hsl(var(--lxra-gold-hover))] disabled:opacity-60 text-xs uppercase tracking-[0.1em] font-semibold flex-shrink-0"
      >
        {status === 'loading' ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <>
            Subscribe
            <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
          </>
        )}
      </Button>
    </form>
  );
};
